/**
 * Copilot bar panel visibility preference (localStorage + merge helper).
 * User dismissed the CopilotBar while a scenario is active (option A — default open until dismissed).
 */
export const COPILOT_BAR_HIDDEN_STORAGE_KEY = 'CopilotBarHidden';

export const hasCopilotPanelStorageFlag = (key) => {
    try {
        return window.localStorage.getItem(key) !== null;
    } catch {
        return false;
    }
};

export const setCopilotPanelStorageFlag = (key, value = '1') => {
    try {
        window.localStorage.setItem(key, value);
        return true;
    } catch {
        return false;
    }
};

export const removeCopilotPanelStorageFlag = (key) => {
    try {
        window.localStorage.removeItem(key);
        return true;
    } catch {
        return false;
    }
};

/**
 * @param {Object} copilotBarState - Scenario-built bar props (typically includes isOpen from buildConfig).
 * @returns {Object} Same shape with isOpen merged against {@link COPILOT_BAR_HIDDEN_STORAGE_KEY}.
 */
export const mergeCopilotBarOpenWithUserPreference = (copilotBarState) => {
    const userHidBar = hasCopilotPanelStorageFlag(COPILOT_BAR_HIDDEN_STORAGE_KEY);

    return {
        ...copilotBarState,
        isOpen: Boolean(copilotBarState.isOpen) && !userHidBar,
    };
};
